import mainBgImage from "@assets/images/background/main.svg";
import { SHStack } from "@components/design-systems";
import { styled } from "@mui/material";

export const PortfolioSetupTableWrapper = styled(SHStack)(
  ({ theme: { palette } }) => {
    return {
      marginTop: 16,
      paddingBottom: 1,
      width: "100%",
      overflow: "scroll",
      position: "relative",
      table: {
        borderBottom: `1px solid ${palette.divider}`,
        "& .MuiTableCell-head": {
          padding: 0,
          paddingLeft: 16,
          height: 40,
        },
        th: {
          borderTop: `1px solid ${palette.divider}`,
          borderBottom: `1px solid ${palette.divider}`,
          "& .MuiTypography-root": {
            opacity: 1,
            zIndex: 2,
            color: palette.common.black,
            filter: "none",
          },
          "&:first-of-type": {
            "&::before": {
              position: "absolute",
              content: '""',
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: `url(${mainBgImage})`,
              backgroundSize: "cover",
              backgroundRepeat: "repeat",
              opacity: 0.6,
              zIndex: 0,
              filter: "blur(0px)",
            },
            borderLeft: `1px solid ${palette.divider}`,
          },
          "&:last-of-type": {
            borderRight: `1px solid ${palette.divider}`,
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: `url(${mainBgImage})`,
              backgroundSize: "cover",
              backgroundRepeat: "repeat",
              backgroundPosition: "right top",
              opacity: 0.7,
              zIndex: 0,
              transform: "scaleX(-1)",
              filter: "blur(8px)",
            },
            zIndex: 1,
            "& .MuiTypography-root": {
              opacity: 1,
              zIndex: 2,
              color: "black",
              filter: "none",
            },
          },
          paddingY: "0px !important",
        },
        tbody: {
          tr: {
            td: {
              "&:first-of-type": {
                borderLeft: `1px solid ${palette.divider}`,
              },
              "&:last-of-type": {
                borderRight: `1px solid ${palette.divider}`,
              },
            },
          },
          "&.MuiTableBody-root::before": {
            lineHeight: "0px",
            fontSize: "0px",
          },
          "& .AnalysisFeePortfolioSetup-table-row": {
            ":nth-of-type(even)": {
              backgroundColor: palette.secondary["50"],
            },
            ":nth-of-type(odd)": {
              backgroundColor: palette.common.white,
            },
            ".MuiTableRow-root": {
              border: `1px solid red !important`,
            },
            ".MuiInput-root": {
              height: "20px !important",
            },
            ".MuiTableCell-root": {
              ":first-of-type": {
                padding: 0,
                paddingLeft: 16,
              },
            },
          },
        },
      },
    };
  },
);
